module.exports = __webpack_public_path__ + "assets/0ed8c7b92e9ea0699fc5f98f0995b8ca.mp3";